import React from 'react';
import cn from 'classnames';
import './style.scss';

export default (props) => (
  <div className={cn('message', {['message--' + props.type]: props.type })}>{props.children}</div>
);
